import { classNames } from '../../utils/style';

export const applyFillColor = (isDisabled, variant, color) => {
  if (isDisabled) return classNames(isDisabled && 'fill-neutral-300');

  return classNames(
    variant === 'primary' && 'fill-white',
    variant === 'secondary' && 'fill-primary-1 group-hover:fill-white',
    variant === 'minimal' && 'fill-primary-1 group-hover:fill-black',
  );
};

export const applyColor = (isDisabled, variant, activeHoverInCard = false) => {
  if (isDisabled)
    return classNames(
      isDisabled && 'text-neutral-300',
      isDisabled && variant === 'primary' && 'bg-neutral-200',
      isDisabled && variant === 'secondary' && 'border-neutral-300',
    );

  return classNames(
    variant === 'primary' &&
      'bg-[#0F6FDE] border-[#0F6FDE] text-white hover:bg-blue-80 hover:border-blue-80 shadow-btnPrimary hover:shadow-btnPrimaryHover transition-all ease-linear',
    variant === 'primary' && 'active:bg-blue-200 active:border-blue-200',
    variant === 'primary' &&
      activeHoverInCard &&
      'group-hover:bg-blue-80 group-hover:border-blue-80',

    variant === 'secondary' && 'text-[#132D4A] hover:text-[#364A61]',
    variant === 'secondary' &&
      'border-neutral-200 bg-white shadow-btnSecondary hover:shadow-btnSecondaryHover transition-all ease-linear',
    variant === 'secondary' &&
      activeHoverInCard &&
      'group-hover:text-[#364A61]',

    variant === 'minimal' &&
      'text-[#0F6FDE] hover:text-[#3587E6] active:text-blue-200',
    variant === 'minimal' && activeHoverInCard && 'group-hover:text-[#3587E6]',
  );
};

export const applyVariant = (variant) => {
  return (
    ['primary', 'secondary'].includes(variant) &&
    classNames('rounded-12 border')
  );
};
